import { render, staticRenderFns } from "./directBankPayment.vue?vue&type=template&id=0280ee94&scoped=true&"
import script from "./directBankPayment.vue?vue&type=script&lang=js&"
export * from "./directBankPayment.vue?vue&type=script&lang=js&"
import style0 from "./directBankPayment.vue?vue&type=style&index=0&id=0280ee94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280ee94",
  null
  
)

export default component.exports